export const NB_SP = '\u00A0';
export const LAQUO = '\u00AB';
export const RAQUO = '\u00BB';
